import React from 'react';
import { Col, Container, Row } from 'reactstrap';

import { PortfolioWithResolve } from '../c/Portfolio';

export default (props) => (
	<Container className="pt-3">
		<Row className="ad_notification_box">
			<Col md="12">
				<PortfolioWithResolve
					show_title={true}
					include_chart={true}
					portfolio_id={props.portfolio_id}
					allow_previously_traded={true}
				/>
			</Col>
		</Row>
		<div className="p-4"/>
	</Container>
);



// WEBPACK FOOTER //
// ./src/p/Portfolio.js